/**
 * GTM/GA4 dataLayer helper. Isolated so analytics consumers (e.g. voipAnalytics, AccountProvider)
 * do not pull in app entry (main.tsx) and its side effects.
 */

export const DATA_LAYER_NAME = "happyDocDataLayer";

declare global {
    interface Window {
        happyDocDataLayer: unknown[];
    }
}

if (typeof window !== "undefined") {
    window[DATA_LAYER_NAME] = window[DATA_LAYER_NAME] || [];
}

export function pushToDataLayer(data: Record<string, unknown>): void {
    if (typeof window !== "undefined" && window[DATA_LAYER_NAME]) {
        window[DATA_LAYER_NAME].push(data);
    }
}
